<template>
  <div class="question-block__container">
    <div class="question-block text-center py-5">
      <div class="question-block__icon">
        <fa-icon
          icon="question-circle"
          size="5x"
        />
      </div>
      <div class="text-thin h5">
        Empecemos por entender qué tan informado estás sobre la carrera de tu interés. <br>
        ¿Cuál crees que es el <strong>salario mensual promedio en {{ careerName }}</strong>?
      </div>
      <div
        v-if="!showResponse"
        class="d-flex justify-content-center align-items-center"
      >
        <div class="mr-2">
          <input
            v-model="response"
            type="range"
            max="100000"
            min="0"
            step="10000"
          >
        </div>
        <div class="d-flex align-items-center">
          <span> {{ response | currency }} </span>
          <div class="ml-2">
            RD$
          </div>
        </div>
      </div>
      <div
        v-if="showResponse"
        class="d-flex justify-content-center align-items-center"
      >
        <p>{{ appResponse }}</p>
      </div>
      <base-button
        v-if="!showResponse"
        @click="onResponse"
      >
        Responder
      </base-button>
      <base-button
        v-if="showResponse"
        @click="onSubmit"
      >
        Conocer más
      </base-button>
    </div>
    <div
      class="question-block__backdrop"
      :class="{'question-block__backdrop--active': showBackdrop}"
    />
  </div>
</template>

<script>
export default {
    name: 'SalaryQuestion',
    props: {
        careerName: {
            type: String,
            required: true,
        },
        careerAverage: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            showResponse: false,
            appResponse:
                'Estamos recopilando datos para entregarte información detallada sobre esta carrera',
            response: 1,
            showBackdrop: false,
        };
    },
    mounted() {
        setTimeout(() => {
            this.showBackdrop = true;
        }, 500);
    },
    methods: {
        onSubmit() {
            const jsonResponse = {
                guess: parseFloat(this.response),
                real: this.careerAverage,
            };
            this.$emit('answered', 'salary', jsonResponse);
        },
        onResponse() {
            const averageSalary = Math.trunc(this.careerAverage);
            let salaryString = this.$options.filters.number(averageSalary);
            salaryString = salaryString.replace(/\./gi, ',');
            this.showResponse = true;
            const margin = 0.15;
            const lowerBound = averageSalary - averageSalary * margin;
            const upperBound = averageSalary + averageSalary * margin;
            const excess = Math.abs(
                Math.trunc((averageSalary * 100) / this.response - 100),
            );
            if (this.response < lowerBound) {
                this.appResponse = 'El salario promedio de quienes se gradúan de '.concat(
                    this.careerName,
                    ' es de $',
                    salaryString,
                    ' al mes. ¡',
                    excess.toString(),
                    '% más de lo que pensabas!',
                );
            } else if (this.response > upperBound) {
                this.appResponse = 'El salario promedio de quienes se gradúan de '.concat(
                    this.careerName,
                    ' es de ',
                    salaryString,
                    ' RD$ al mes. ¡',
                    excess.toString(),
                    '% menos de lo que pensabas!',
                );
            } else {
                this.appResponse = 'El salario promedio de quienes se gradúan de '.concat(
                    this.careerName,
                    ' es de $',
                    salaryString,
                    ' al mes. ¡Muy bien! tu respuesta ha sido muy cercana a la cifra oficial.',
                );
            }
        },
    },
};
</script>
<style lang="scss">
@import "../../scss/style";
.question-block {
    position: relative;
    z-index: 99999;
    background-color: white;
    border-radius: 5px;

    &__icon {
        color: $primary;
    }
    & > div {
        margin-bottom: 1rem;
    }
    &__response {
        max-width: 80px;
        text-align: right;

        &[type="number"]::-webkit-inner-spin-button,
        &[type="number"]::-webkit-outer-spin-button {
            display: none;
        }
    }

    &__backdrop{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(black, 0.8);
      backdrop-filter: blur(2px);
      z-index: 99998;
      opacity: 0;
      transition: all 0.5s;

      &--active{
        opacity: 1;
      }
    }
}
</style>
